import bugsnag from '@bugsnag/js';
import { BUGSNAG_API_KEY, ENVIRONMENT } from './config';

const bugsnagClient = bugsnag({
  apiKey: BUGSNAG_API_KEY!,
  notifyReleaseStages: ['production'],
  releaseStage: ENVIRONMENT!,
});
(window as any).bugsnag = bugsnagClient;
